import $$ from 'cmn-utils'

const baseUrl = "/api/device/state/";
export default {
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    fieldList: (params) => {
        return $$.get(baseUrl + 'field-list', params)
    },
    timeSequence: (params) => {

        if (params.startTime) {
            params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endTime) {
            params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
        }
        return $$.get(baseUrl + 'time-sequence', params)
    },
    timeSequenceV2: (params) => {
        if (params.startTime) {
            params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endTime) {
            params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
        }
        return $$.get(baseUrl + 'time-sequence-v2', params)
    },
    timeSequenceV3:  (params) => {
        if (params.startTime) {
            params.startTime = params.startTime.format("YYYY-MM-DD HH:mm:ss");
        }
        if (params.endTime) {
            params.endTime = params.endTime.format("YYYY-MM-DD HH:mm:ss");
        }
        return $$.get(baseUrl + 'time-sequence-v3', params)
    },
}